let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gZRQV")).then(() => parcelRequire('aZFM8'));